import { motion } from 'framer-motion';
import { EXPERIENCE } from '../data/projects';

const Experience = () => {
  return (
    <section id="experience" className="section experience">
      <div className="section__inner">
        <motion.p
          className="section__eyebrow"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Experience
        </motion.p>
        <motion.h2
          className="section__title"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          Where I&apos;ve shipped
        </motion.h2>

        <div className="timeline">
          {EXPERIENCE.map((job, index) => (
            <motion.article
              key={job.id}
              className="timeline__item"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{
                duration: 0.7,
                delay: index * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <div className="timeline__meta">
                <span className="timeline__period">{job.period}</span>
                <h3 className="timeline__role">{job.role}</h3>
                <p className="timeline__company">{job.company}</p>
              </div>
              <ul className="timeline__points">
                {job.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
